import { createAction, props } from '@ngrx/store';

export const selectShop = createAction('[Shop] Select Shop', props<{ shop: any }>());
export const clearShopState = createAction('[Shop] Clear Shop State');
